export default __webpack_public_path__ + "static/media/PigMinus.fc3201e9.png";